import { Observable } from 'rxjs';

export abstract class UserSessionPort {
	public abstract observeJwToken(): Observable<string>;

	public abstract closeSession(): void;

	public abstract getJwToken(): string;
}
